import { render, staticRenderFns } from "./error-message.vue?vue&type=template&id=2fea8126&lang=pug&"
import script from "./error-message.vue?vue&type=script&lang=js&"
export * from "./error-message.vue?vue&type=script&lang=js&"
import style0 from "./error-message.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports